import type {FinishedResponseInteractionService} from 'shared/services';
import type {ModalDialogService} from 'shared/modal-dialogs';
import type {LocalizationService} from 'shared/providers';
import type {ActionResponse, User} from 'src/typings';
import type UserService from 'src/features/user/user.service';
import {createFinishedResponseActionResponse} from 'src/modals/modal-utils';

export class DiscountRequestModalPresenter {
    public static presenterName = 'discountRequestModalPresenter'

    /*@ngInject*/
    constructor(private localizationService: LocalizationService,
                private userService: UserService,
                private finishedResponseInteractionService: FinishedResponseInteractionService,
                private modalDialogService: ModalDialogService) {
    }

    public async uploadUserFiles(user: User, showSuccessModal: boolean): Promise<ActionResponse> {
        try {
            await this.modalDialogService.openModalWindow('userFilesUpload', {user});
            const actionResponse = createFinishedResponseActionResponse(this.localizationService.get(/* @kp-localization discount.request.DiscountEligibilityMessage */ 'discount.request.DiscountEligibilityMessage'));
            if (showSuccessModal) {
                await this.finishedResponseInteractionService.showSuccessResponseInModalWindow(actionResponse);
            }
            return actionResponse;
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedInModalWindow(exceptionResponse);
            return null;
        }
    }

    public async editIsic(user: User) {
        return this.userService.editIsic(user);
    }
}